import { fromJcamp as commonFromJcamp } from 'common-spectrum';
import { spectrumCallback as defaultSpectrumCallback } from "./utils/spectrumCallback.js";
/**
 * Creates a new Analysis from a JCAMP string or buffer.
 * @param jcamp - JCAMP data as a string or ArrayBuffer.
 * @param options - Options for the analysis.
 * @returns New Analysis element with the given data.
 */
export function fromJcamp(jcamp, options = {}) {
    const { spectrumCallback = defaultSpectrumCallback, ...rest } = options;
    return commonFromJcamp(jcamp, { ...rest, spectrumCallback });
}
//# sourceMappingURL=fromJcamp.js.map